import { render } from "./FactureAchatDetailModal.vue?vue&type=template&id=66982707&scoped=true"
import script from "./FactureAchatDetailModal.vue?vue&type=script&lang=js"
export * from "./FactureAchatDetailModal.vue?vue&type=script&lang=js"

import "./FactureAchatDetailModal.vue?vue&type=style&index=0&id=66982707&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66982707"]])

export default __exports__